



























































































import ApiClient from '@/services/api-client'
import { Component, Vue, Watch } from 'vue-property-decorator'
import ApiGtag, { Category } from '@/services/api-gtag'
import Utils from '@/utils'

@Component
export default class Preview extends Vue {
  private isActive = false
  private url = 'about:blank'
  private fullWindowPreview = false

  loadPreview() {
    this.url = 'about:blank'
    if (this.$route.name === 'FullWindowPreview') {
      this.fullWindowPreview = true
    }
    const productId = this.$route.params.productId
    const unitId = this.$route.params.workModuleCode || 'bl01sa01'
    ApiClient.getPreviewUrl(productId, unitId).then((url) => {
      const previewMode = location.href.includes('fast') ? 'fast' : 'fine'
      const params = new URLSearchParams(location.search)
      const subjectData = params.get('course') || 'lengua'
      this.url = url.concat(`?course=${subjectData}&mode=${previewMode}`)
    })
  }

  created() {
    this.loadPreview()
    ApiGtag.sendEvent(
      Category.User,
      'Preview unit',
      `${this.$route.params.productId}/${this.$route.params.workModuleCode}`
    )
  }

  mounted() {
    this.setPageTitle()
  }

  private downloadWorkModule() {
    const product = this.$store.state.activeProduct
    const workModule = Utils.getCurrentWorkModule(product, this.$route.params.workModuleCode)
    if (product && workModule) {
      ApiClient.downloadWorkModule(product, workModule)
    }
  }

  @Watch('$store.state.activeProduct')
  setPageTitle() {
    const product = this.$store.state.activeProduct
    const workModule = Utils.getCurrentWorkModule(product, this.$route.params.workModuleCode)

    if (!this.fullWindowPreview && workModule) {
      window.document.title = `${this.$i18n.t('pageTitle.preview')} ${
        product.title
      } / ${workModule?.title} - LDX`
    } else if (this.fullWindowPreview) {
      window.document.title = `${this.$i18n.t('pageTitle.preview')} ${
        this.$route.params.productId
      } / ${this.$route.params.workModuleCode} - LDX`
    }
  }
}
